import { render, staticRenderFns } from "./SVGShadeOn.vue?vue&type=template&id=605cea05&scoped=true&"
import script from "./SVGShadeOn.vue?vue&type=script&lang=js&"
export * from "./SVGShadeOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605cea05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605cea05')) {
      api.createRecord('605cea05', component.options)
    } else {
      api.reload('605cea05', component.options)
    }
    module.hot.accept("./SVGShadeOn.vue?vue&type=template&id=605cea05&scoped=true&", function () {
      api.rerender('605cea05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGShadeOn.vue"
export default component.exports